import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
// import Swiper and modules styles
import "swiper/css";

document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".swiper", {
    // configure Swiper to use modules
    modules: [Navigation, Pagination, Autoplay],

    spaceBetween: 40,
    slidesPerView: 3,

    autoplay: {
      delay: 3000,
    },

    navigation: {
      enabled: true,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    pagination: {
      enabled: true,
      el: ".swiper-pagination",
      bulletClass: "swiper-bullet",
      bulletActiveClass: "swiper-bullet-active",
      clickable: true,
    },

    breakpoints: {
      1024: {
        slidesPerView: 3,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
});
